import config from '../config'
import { Storage } from 'aws-amplify'

import 'whatwg-fetch'
import Axios from 'axios'

function randomName() {
  // 生成する文字列の長さ
  const l = 64

  // 生成する文字列に含める文字セット
  const c = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_-'

  const cl = c.length
  let r = ''
  for (var i = 0; i < l; i++) {
    r += c[Math.floor(Math.random() * cl)]
  }
  return r
}

export default {
  namespaced: true,
  state: {
    company_id: null,
  },
  mutations: {

  },
  actions: {
    put(context, putData) {
      return new Promise((resolve) => {
        if (context.state.company_id) {
          context.dispatch('putFile', putData)
            .then((result) => {
              resolve(result)
            })
            .catch(err => {
              resolve(err)
            })
        } else {
          Axios.get(`${config.CommonApiUrl}/masters`,
            {
              headers: {
                Authorization: context.rootGetters['auth/authorization'],
              },
            })
            .then((result) => {
              context.state.company_id = result.data.company.id
              context.dispatch('putFile', putData)
                .then((result) => {
                  resolve(result)
                })
                .catch(err => {
                  resolve(err)
                })
            })
            .catch(err => {
              resolve(err)
            })
        }
      })
    },
    putFile(context, putData) {
      return new Promise((resolve) => {
        const folder = putData.folder
        const file = putData.file
        const name = file.name.replace(/[&/\\#,+()$~%.'":*?<>{}!@^=`;|[]\s]/g, '_')
        const hash = randomName()
        Storage.put(`${context.state.company_id}/${folder}/${hash}/${name}`, file, {
          contentType: file.type,
          level: 'public',
        })
          .then(result => {
            resolve(result)
          })
          .catch(err => {
            resolve(err)
          })
      })
    },


  },
  getters: {

  },
}
